import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { CollaborationTemplateDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import { useQuery } from 'react-query';
import api from '@/utils/httpClient';

export const getTemplate = (id: string) => {
  return api
    .get(`/api/collaborationtemplates/${id}`)
    .then((response) => (response.data as ApiResponse<CollaborationTemplateDto>).data);
};

export const useGetTemplate = (templateId: string) => {
  return useQuery(['template', templateId], () => getTemplate(templateId), {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity
  });
};
